export default "__VITE_ASSET__Bp8ks3c1__"